/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { QuartzJobState } from './quartzJobState';
import { QuartzScheduleType } from './quartzScheduleType';


export interface QuartzJobDetails { 
    job_name?: string;
    job_group?: string;
    description?: string;
    job_class_name?: string;
    job_data?: string;
    state?: QuartzJobState;
    schedule_type?: QuartzScheduleType;
    cron_expression?: string;
    repeat_interval?: number;
    repeat_count?: number;
    next_fire_time?: Date;
    previous_fire_time?: Date;
    trigger_data?: string;
    execution_count_in_queried_hours?: number;
}
export namespace QuartzJobDetails {
}


